import React from "react";
import { Row, Spinner } from "react-bootstrap";
import { ArrowLeft } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { TermsUIProps } from "./Terms.types.tsx";

import { TitleLabel, GreenLabel, TermsText } from "../Labels.tsx";

import { useTheme } from "../../context/Theme.context.tsx";

const TermsFormUI: React.FC<TermsUIProps> = ({ onBackToLogin, isLoading, terms }) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  if (isLoading) {
    const spinnerVariant = theme === "dark" ? "light" : "dark";

    return (
      <div className="d-flex justify-content-center my-5">
        <Spinner variant={spinnerVariant} />
      </div>
    );
  }

  return (
    <Row style={{ maxWidth: 600 }} className="mx-auto">
      <TitleLabel>{t("terms.title")}</TitleLabel>

      <TermsText>{terms}</TermsText>

      <GreenLabel onClick={onBackToLogin}>
        <ArrowLeft />
        {t("terms.backToLogin")}
      </GreenLabel>
    </Row>
  );
};

export default TermsFormUI;
